import { config } from '../../config/env';

export type LocationStoreInfo = {
  storeCode: string;
  afcEnabled?: boolean;
  afcStoreCodes?: Array<string | number>;
};

type GetAfcStoresByStoreCodeParams = {
  countryCode: string;
  storeCodes: string[];
};

export const getAfcStoresByStoreCode = async ({
  countryCode,
  storeCodes,
}: GetAfcStoresByStoreCodeParams): Promise<LocationStoreInfo[]> => {
  const baseEndpoint = config.LOCATION_SERVICE_URL.replace(/\/$/, '');

  if (!baseEndpoint) {
    throw new Error('Missing location service URL');
  }

  const query = new URLSearchParams({ storeCodes: storeCodes.join(',') });
  const endpoint = `${baseEndpoint}/${encodeURIComponent(countryCode)}/store/?${query.toString()}`;
  const response = await fetch(endpoint, {
    method: 'GET',
    headers: { Accept: 'application/json, text/plain, */*' },
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  const storeInfo: unknown = await response.json();
  if (!Array.isArray(storeInfo)) {
    throw new Error('Invalid location service response');
  }

  return storeInfo as LocationStoreInfo[];
};
